import { useRef } from 'react';

export function useShallowMemo<T>(factoryFunction: () => T, dependencies: unknown[]): T {
  const initialValue = factoryFunction();
  const prevDependenciesRef = useRef<unknown[]>([]);
  const prevValueRef = useRef<T>(initialValue);

  const hasDifferentLength = dependencies.length !== prevDependenciesRef.current.length;

  const dependenciesChanged =
    hasDifferentLength === true ||
    dependencies.some((dep, i) => Object.is(dep, prevDependenciesRef.current[i]) === false);

  if (dependenciesChanged) {
    prevDependenciesRef.current = [...dependencies];
    prevValueRef.current = factoryFunction();
  }

  return prevValueRef.current!;
}
